export default "__VITE_ASSET__DZT2cB8e__"